import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Route, Routes } from 'react-router-dom';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';
import { sharedResolution } from '../../src/shared_resolution';
import { Root, createRoot } from 'react-dom/client';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { UniversalConfig } from '@application/universal_config.service';
import { CookiePolicy } from '@view/cookie_policy/mod';

const containerElementName = 'CookiePolicyWrapper';

@Component({
	standalone: false,
	selector: 'cookie-policy-component',
	template: `
		<semantic-view>
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
	styles: [
		`
			p,
			span,
			h1,
			h2,
			h3,
			h4,
			h5,
			h6,
			h7,
			h8,
			h9 {
				margin-bottom: 0;
			}
		`,
	],
})
export class CookiePolicyWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(private readonly ngZone: NgZone) {
		// Empty
	}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private async render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const universalConfigService = sharedResolution.resolve(UniversalConfig);

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
						<Routes>
							<Route path='cookie-policy/*' element={<CookiePolicy />} />
						</Routes>
					</ProgrammaticBrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}
